import { UserProfile } from './UserProfile.main';

export { UserProfile };
